import * as React from 'react'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import '../css/gdpr.css'
import {ACCENT_TEXT_FW500, setTitleFont, tagger} from '../util/util'

const PrivacyDsp = () => {
    const {t, i18n} = useTranslation('privacyDsp')
    const activator = (e: any) => e.currentTarget.parentElement.lastChild.classList.toggle('active')

    useEffect(() => {
        setTitleFont(i18n.language)
    }, [])

    return (
        <div className="common-pages-container">
            <p className="title muli">{tagger(t('personaly dsp'), ACCENT_TEXT_FW500)}</p>
            <div className="text">[Last Revised: April 26, 2018]</div>
            <div className="text">{tagger(t('op vision ltd'), ACCENT_TEXT_FW500)}</div>
            <div className="text">
                {tagger(t('personaly recognizes p1'), ACCENT_TEXT_FW500)}
                <Link to="/">www.Persona.ly</Link>
                {tagger(t('personaly recognizes p2'), ACCENT_TEXT_FW500)}
            </div>
            <div className="text" style={{border: '1px solid #00d4f8', padding: '8px'}}>{tagger(t('acceptance of the terms'), ACCENT_TEXT_FW500)}</div>
            <div className="text">{tagger(t('this policy c'), ACCENT_TEXT_FW500)}</div>
            <ul className="ul-decimal">
                <li>{t('types of i')}</li>
                <li>{t('data collected f')}</li>
                <li>{t('data we c')}</li>
                <li>{t('use of your i')}</li>
                <li>{t('how we c')}</li>
                <li>{t('data collection b')}</li>
                <li>{t('third party c')}</li>
                <li>{t('sharing your i')}</li>
                <li>{t('your choices and c')}</li>
                <li>{t('targeted ad')}</li>
                <li>{t('children p')}</li>
                <li>{t('data security')}</li>
                <li>{t('data r')}</li>
                <li>{t('transfer of d')}</li>
                <li>{t('do not track')}</li>
                <li>{t('data protection o')}</li>
                <li>{t('modifications and u')}</li>
                <li>{t('contact us')}</li>
            </ul>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('types of inf')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('the first type o'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('the second type o'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('please note that we'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('data collected'), ACCENT_TEXT_FW500)}</p>
                    <ul className="ul-disc">
                        <li>{tagger(t('registration d'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('identifiers c'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('payment a'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('technical w'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('newsletter subscription'), ACCENT_TEXT_FW500)}</li>
                    </ul>
                    <p className="text">{tagger(t('data we collect'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{t('when using a p')}</p>
                    <ul className="ul-disc">
                        <li>{t('approximate g')}</li>
                        <li>{t('carrier, isps')}</li>
                        <li>{t('device properties s')}</li>
                        <li>{t('user clickstream')}</li>
                        <li>{t('internet browser')}</li>
                        <li>{tagger(t('certain identifiers'), ACCENT_TEXT_FW500)}</li>
                    </ul>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('use of your i')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('personaly uses t'), ACCENT_TEXT_FW500)}</p>
                    <ul className="ul-disc">
                        <li>{t('enhance your ex')}</li>
                        <li>{t('to operate, pr')}</li>
                        <li>{t('to optimize the c')}</li>
                        <li>{t('perform research')}</li>
                        <li>{t('to respond to y')}</li>
                        <li>{t('protect our or t')}</li>
                        <li>{t('to audit and t')}</li>
                    </ul>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('how we collect i')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('depending on the nature'), ACCENT_TEXT_FW500)}</p>
                    <ul className="ul-upper-latin">
                        <li>{t('automatically, inc')}</li>
                        <li>{t('when you voluntarily')}</li>
                    </ul>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('data collection b')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{t('when you access or')}</p>
                    <p className="text">{t('the cookies and s')}</p>
                    <p className="text">{t('for more inf')}</p>
                    <ul className="ul-disc">
                        <li><a href="https://support.google.com/chrome/answer/95647?hl=en;">https://support.google.com/chrome/answer/95647?hl=en (Chrome);</a></li>
                        <li><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences">https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences (Firefox);</a></li>
                        <li><a href="http://www.opera.com/help/tutorials/security/cookies/">http://www.opera.com/help/tutorials/security/cookies/ (Opera);</a></li>
                        <li><a href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies">https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies (Internet Explorer);</a></li>
                        <li><a href="https://support.apple.com/kb/PH21411">https://support.apple.com/kb/PH21411 (Safari);</a> {t('and')}</li>
                        <li><a href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy">https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy (Edge).</a></li>
                    </ul>
                    <p className="text">{t('most browsers will')}</p>
                    <p className="text">{t('third parties')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('third party c')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('the service may'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('sharing your i')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('personaly will not'), ACCENT_TEXT_FW500)}</p>
                    <ul className="ul-lower-latin">
                        <li>{tagger(t('authorized disclosures'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('compelled disclosures'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('service providers'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('business transfers'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('non-personal information'), ACCENT_TEXT_FW500)}</li>
                    </ul>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('your choices and c')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{t('your principal rights')}</p>
                    <ul className="ul-lower-latin">
                        <li>{t('the right to access')}</li>
                        <li>{t('the right to rectification')}</li>
                        <li>{t('the right to erasure')}</li>
                        <li>{t('the right to restrict')}</li>
                        <li>{t('the right to object')}</li>
                        <li>{t('the right to data')}</li>
                        <li>{t('the right to complain')}</li>
                        <li>{t('the right to withdraw')}</li>
                    </ul>
                    <p className="text">{tagger(t('we provide you with'), '', 'mailto:support@persona.ly')}</p>
                    <p className="text">{tagger(t('if you would like ad'), '', 'mailto:support@persona.ly')}<a href="mailto:victor@persona.ly">victor@persona.ly</a>.</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('targeted ad')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{t('even after providing')}</p>
                    <p className="text">{t('options to opt out')}</p>
                    <ul className="ul-disc">
                        <li>{tagger(t('learn how to opt-out from android'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('learn how to opt-out from ios'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('you may control how your'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('you may opt out of certain'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('if you wish to opt out of interest'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('our Publishers may also'), ACCENT_TEXT_FW500)}</li>
                    </ul>
                    <p className="text">{t('in the event, that')}</p>
                    <p className="text">{tagger(t('you may also contact'), '', 'mailto:support@persona.ly')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('children p')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('you represent and warrant'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('data security')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">
                        {tagger(t('your privacy is very'), '', '/security')}
                        {tagger(t('in addition, some of'), ACCENT_TEXT_FW500)}
                        {tagger(t('furthermore, some of the'), ACCENT_TEXT_FW500)}
                    </p>
                    <p className="text">{tagger(t('personaly also protects'), '', 'mailto:support@persona.ly')}</p>
                    <p className="text">{t('further, in the event')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('data r')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{t('we retain the non-personal')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('transfer of d')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{t('as a part of an international')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('do not track')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('the service does not respond'), '', 'http://www.allaboutdnt.com/')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('data protection o')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('if you have any requests'), '', 'mailto:victor@persona.ly')}</p>
                    <p className="text">{t('please be sure to include')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('modifications and u')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{t('we reserve the right')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('contact us')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg" />
                </div>
                <div className="accordion-content">
                    <p className="text">{t('if you have any questions')}</p>
                    <p className="text">
                        <span className="accent-text">O.P Vision LTD dba Persona.ly</span>
                        <br />Meir Weissgal Rd. 2, Rehovot
                        <br />{tagger(t('you can also contact'), '', 'mailto:support@persona.ly')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default PrivacyDsp


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/privacyDsp.tsx